import React from 'react';
import { rateColor } from './v4Format';

const pad = (n) => String(n).padStart(2, '0');

// Trading-day calendar for the user 💀 V4 folder (6:30 AM → 6:30 AM Adelaide days).
export const V4Calendar = ({ days, month, setMonth, selectedDay, onSelect }) => {
  const y = month.getFullYear();
  const mo = month.getMonth();
  const first = new Date(y, mo, 1).getDay();
  const daysInMonth = new Date(y, mo + 1, 0).getDate();
  const cells = [...Array(first).fill(null), ...Array.from({ length: daysInMonth }, (_, i) => i + 1)];
  const navBtn = { border: '1px solid #fecaca', background: '#fef2f2', color: '#991b1b', borderRadius: 8, padding: '4px 12px', fontWeight: 800, cursor: 'pointer' };
  return (
    <div data-testid="user-v4-calendar" style={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: 10, padding: '0.85rem 1rem', marginBottom: '1rem' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
        <button data-testid="user-v4-cal-prev" onClick={() => setMonth(new Date(y, mo - 1, 1))} style={navBtn}>◀</button>
        <div data-testid="user-v4-cal-month" style={{ fontWeight: 800, color: '#1e293b', fontSize: '0.95rem' }}>
          {month.toLocaleString(undefined, { month: 'long', year: 'numeric' })}
        </div>
        <button data-testid="user-v4-cal-next" onClick={() => setMonth(new Date(y, mo + 1, 1))} style={navBtn}>▶</button>
      </div>
      <div style={{ fontSize: '0.68rem', color: '#94a3b8', marginBottom: '0.5rem' }}>
        Win rate for each trading day (6:30 AM → 6:30 AM Adelaide). Green = 85%+ · amber = 60–84% · red = under 60%. Tap a day to see only its trades.
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)', gap: 4, marginBottom: 4 }}>
        {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((w) => (
          <div key={w} style={{ textAlign: 'center', fontSize: '0.62rem', fontWeight: 700, color: '#94a3b8' }}>{w}</div>
        ))}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)', gap: 4 }}>
        {cells.map((d, idx) => {
          if (d === null) return <div key={`e${idx}`} />;
          const ds = `${y}-${pad(mo + 1)}-${pad(d)}`;
          const info = days[ds];
          const has = !!info;
          const graded = has && info.finalized > 0;
          const sel = selectedDay === ds;
          const rate = graded ? info.win_rate : null;
          const bg = sel ? '#1e293b' : graded ? (rate >= 85 ? '#dcfce7' : rate >= 60 ? '#fef9c3' : '#fee2e2') : has ? '#f1f5f9' : '#f8fafc';
          return (
            <button key={ds} data-testid={`user-v4-cal-day-${ds}`} disabled={!has} onClick={() => onSelect(sel ? null : ds)}
              title={has ? `${info.wins} wins / ${info.losses} losses · ${info.total} trades` : 'no trades'}
              style={{ border: sel ? '2px solid #0f172a' : '1px solid #e2e8f0', background: bg, color: sel ? 'white' : has ? '#0f172a' : '#cbd5e1', borderRadius: 8, padding: '4px 2px', cursor: has ? 'pointer' : 'default', minHeight: 46, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 1, touchAction: 'manipulation' }}>
              <span style={{ fontSize: '0.8rem', fontWeight: 700 }}>{d}</span>
              {graded && <span style={{ fontSize: '0.6rem', fontWeight: 700, color: sel ? 'white' : rateColor(rate) }}>{rate}%</span>}
              {has && !graded && <span style={{ fontSize: '0.6rem', color: sel ? 'white' : '#94a3b8' }}>⏳</span>}
              {has && <span style={{ fontSize: '0.62rem', fontWeight: 600, color: sel ? '#e2e8f0' : '#64748b' }}>{info.total}t</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
};
